"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETechnicalSignature = void 0;
exports.ETechnicalSignature = {
    manual: "manual",
    auto: "auto",
};
